.root {
  width: 100%;
}

.coordinates {
  position: relative;
  height: 300px;
}

.x,
.y {
  position: absolute;
  background-color: var(--blue-200);
}

.x {
  top: 50%;
  width: 100%;
  height: 2px;
}

.y {
  left: 50%;
  width: 2px;
  height: 100%;
}

.channel {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  font-size: 10px;
  color: var(--widget-subheader-color);
  cursor: pointer;
  border-radius: var(--radius-full);
  transform: translate(-50%, -50%);
  transition: opacity 0.4s cubic-bezier(0.075, 0.82, 0.165, 1);
}

.visible {
  opacity: 1;
}

.top {
  position: absolute;
  top: 0;
  left: 50%;
  color: var(--white);
  background-color: var(--blue-700);
  transform: translateX(-50%);
}

.left {
  position: absolute;
  top: 50%;
  left: 0;
  background-color: var(--sentiment-negative);
  transform: translateY(-50%);
}

.right {
  position: absolute;
  top: 50%;
  right: 0;
  background-color: var(--sentiment-positive);
  transform: translateY(-50%);
}

.bottom {
  position: absolute;
  bottom: 0;
  left: 50%;
  color: var(--gray-900);
  background-color: var(--blue-300);
  transform: translateX(-50%);
}

.img {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 105%;
  height: 105%;
  object-fit: cover;
  transform: translate(-50%, -50%);
}

.info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-width: 240px;
  padding: 0.75rem;

  header {
    display: flex;
    gap: 10px;
    align-items: center;
  }

  .cover {
    flex-shrink: 0;
    width: 50px;
    height: 50px;
    overflow: hidden;
    object-fit: cover;
    border-radius: var(--radius-full);
  }

  .description {
    position: relative;
    max-height: 140px;
    overflow: hidden;

    &::before {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 1rem;
      content: "";
      background: linear-gradient(
        to bottom,
        transparent,
        var(--dropdown-background)
      );
    }
  }

  .descriptionInner {
    padding-bottom: 1rem;
    text-overflow: ellipsis;
  }

  .channelName {
    font-weight: var(--font-weight-medium);
  }
}

.infoImage {
  width: 50px;
  height: 50px;
  overflow: hidden;
  object-fit: cover;
  border-radius: var(--radius-full);
  opacity: 0;
}
